import { createBrowserRouter, Navigate } from 'react-router';
import { Suspense } from 'react';
import { BaseLayout } from '@shared/layouts';
import { ProtectedRoute } from '@features/auth';
import { GlobalLoader } from '@shared/components';
import {
    Login,
    Dashboard,
    Departments,
    Profile,
    RequestsList,
    RequestNew,
    RequestDetail,
    RequestEdit,
    Calendar,
    Patterns,
    Notifications,
} from '@pages';
import styles from './router.module.css';

const fallback = <GlobalLoader className={styles.loadingSpinner} />;

export const router = createBrowserRouter([
    {
        path: '/',
        element: (
            <Suspense fallback={fallback}>
                <ProtectedRoute />
            </Suspense>
        ),
        children: [
            {
                element: <BaseLayout />,
                children: [
                    { index: true, element: <Dashboard /> },
                    ...(import.meta.env.VITE_DEV_MODE === 'true'
                        ? [
                              { path: 'calendar', element: <Calendar /> },
                              { path: 'patterns', element: <Patterns /> },
                          ]
                        : []),
                    { path: 'requests', element: <RequestsList /> },
                    { path: 'requests/new', element: <RequestNew /> },
                    { path: 'requests/:id', element: <RequestDetail /> },
                    { path: 'requests/:id/edit', element: <RequestEdit /> },
                    { path: 'departments', element: <Departments /> },
                    { path: 'profile', element: <Profile /> },
                    ...(import.meta.env.VITE_DEV_MODE === 'true'
                        ? [
                              {
                                  path: 'notifications',
                                  element: <Notifications />,
                              },
                          ]
                        : []),
                ],
            },
        ],
    },
    {
        path: '/login',
        element: <Login />,
    },
    {
        path: '*',
        element: (
            <Navigate
                to="/login"
                replace
            />
        ),
    },
]);

export default router;
